(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').directive('myPlan', MyPlan);

  function MyPlan() {
    return {
      restrict: 'E',
      scope: {
        selectedBan: '=',
        selectedCtn: '=',
        billingProvince: '=',
        ppcPermitted: '=',
        hupPermitted: '=',
        initPpc: '=',
        initHup: '='
      },
      templateUrl: 'modules/my-account/wireless/my-plan/my-plan.view.html',
      controller: 'myPlanController',
      controllerAs: 'mpCtrl',
      bindToController: true
    };
  }

})();
